export const environment = {
  production: false,
  api_url:'/appsFrontGenerales',
  api_url_bursanet_qa:'https://qa-api.actinver.com.mx',
  api_url_bursanet_prod:'https://api.actinver.com.mx',
  base_url: window.location.origin,
  headers_token:{
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Basic TUh4VWlUdkdlY3N6YWJkaktpNU1HR2k4b3ByTTVFQ206Ym5USGJ0TmlNRGZBUHZMUQ=='
  },  
  headers_token_prod:{
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Basic aEJWbmM2eHNSdEdDUGV3SlJsUERSeGxBQVF1RTJibnc6MUdLa0lBZGVDekFERENVRQ=='
  },
  services:{
    countries:'/Catalogs/pais',    
    actionCntrtsAllSteps: '/InteractiveContratosController/actionCntrtsAllSteps',
    tipoIdentificacion: '/Catalogs/tipoIdentificacion',
    actionUploadFile:'/InteractiveContratosController/actionUploadFile',
    typesAddress: '/Catalogs/tipoVivienda',
    occupations: '/Catalogs/ocupacion',
    civilStatus: '/Catalogs/estadoCivil',
    catCountries: '/InteractiveCatalogsController/actionCatPais',
    catEstates: '/InteractiveCatalogsController/actionReadAllStates?bland=all',
    catSuburbs:'/InteractiveCatalogsController/actionReadColonias',
    catRelationship: '/InteractiveCatalogsController/ListTipoParentesco',
    catCitiesByCode: '/InteractiveCatalogsController/actionReadCiudades',
    catTownsByCode: '/InteractiveCatalogsController/actionReadDomicilios',
    catSuburbsByCode: '/InteractiveCatalogsController/actionReadColonias',
    catTypeAddress: '/InteractiveCatalogsController/actionCatTipoDomicilio',
    addBeneficiary:'/InteractiveContratosController/actionSaveBeneficiarios',
    updateBeneficiary:'/InteractiveContratosController/actionUpdateBeneficiarios',
    saveStepOne: '/InteractiveContratosController/actionContractStep1',
    saveStepTwo: '/InteractiveContratosController/actionContractStep2',
    saveStepThree: '/InteractiveContratosController/actionContractStep3',
    saveStepFour: '/InteractiveContratosController/actionContractStep4',
    saveAllSteps: '/InteractiveContratosController/actionContractStep234',
    prospectClientRegistration: '/noauth/clientManagement/v1_0/prospectClientRegistration?language=SPA',
    accountBursanet:'/client-bursanet/accountBursanet'
  },
  services_api:{
    accesstoken: '/oauth/accesstoken?grant-type=client_credentials',
    accountBursanet:'/bursanet-resful/client-bursanet/accountBursanet/'
  }
};